import React, { useEffect, useState } from 'react';
import './ToastNotification.scss';
import SvgIcons from '../../services/SvgIcons';

const ToastNotification = ({
    message,
    type = 'success',
    duration = 5000,
    onClose,
    position = 'top-right'
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const [isLeaving, setIsLeaving] = useState(false);
    
    const handleClose = () => {
        setIsLeaving(true);
        setTimeout(() => {
            setIsVisible(false);
            if (onClose) onClose();
        }, 300); // Durée de l'animation de sortie
    };

    useEffect(() => {
        setIsVisible(true);
        const timer = setTimeout(() => {
            handleClose();
        }, duration);

        return () => clearTimeout(timer);
    }, [duration]);


    const getIcon = () => {
        switch (type) {
            case 'success':
                return {
                    name: 'confirm',
                    color: '#22c55e'
                };
            case 'error':
                return {
                    name: 'close',
                    color: '#ef4444'
                };
            case 'info':
                return {
                    name: 'information',
                    color: '#3b82f6'
                };
            case 'warning':
                return {
                    name: 'warning',
                    color: '#f59e0b'
                };
            default:
                return {
                    name: 'confirm',
                    color: '#22c55e'
                };
        }
    };

    if (!isVisible) return null;

    const icon = getIcon();

    return (
        <div 
            className={`toast-notification toast-notification--${position} ${type} ${isLeaving ? 'leaving' : ''}`}
        >
            <div className="toast-notification__icon">
                <SvgIcons
                    name={icon.name}
                    width="24"
                    height="24"
                    color={icon.color}
                />
            </div>
            <div className="toast-notification__content">
                {message}
            </div>
            <button 
                className="toast-notification__close"
                onClick={handleClose}
                aria-label="Fermer la notification"
            >
                <SvgIcons
                    name="close"
                    width="20"
                    height="20"
                    color="#6D4F47"
                />
            </button>
            <div 
                className="toast-notification__progress"
                style={{ animationDuration: `${duration}ms` }}
            />
        </div>
    );
};

export default ToastNotification;